<template>
  <base-modal name="endMeetingModal" width="360">
    <template #body>
      <div class="modal-body mt-6">
        <div class="modal-title">
          <div class="modal-ring-danger">
            <receive-square
              v-if="activeDetail"
              class="m-auto"
              :color="theme === 'light' ? 'var(--color-danger)' : 'var(--color-danger)'"
            />
            <trash
              v-else
              class="m-auto"
              :color="theme === 'light' ? 'var(--color-danger)' : 'var(--color-danger)'"
              width="24"
              height="24"
            />
          </div>
        </div>
        <div class="modal-body mt-50">
          <div class="title-description text-center">
            <span v-if="activeDetail">
              {{ $t('are_you_sure_you_want_to_meeting', { text: $t('end') }) }}
            </span>
            <span v-else>
              {{ $t('are_you_sure_you_want_to_meeting', { text: $t('delete') }) }}
            </span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="footer-button-section gap-15">
          <div>
            <base-button
              radius="default"
              buttonType="cancel"
              width="full"
              height="48"
              @click.native="closeModals('endMeetingModal')"
            >
              <template #text>
                <span class="text-18 font-bold">
                  {{ $t('cancel') }}
                </span>
              </template>
            </base-button>
          </div>
          <div>
            <base-button
              v-if="activeDetail"
              radius="default"
              buttonType="danger-opacity"
              width="full"
              height="48"
              @click.native="$emit('endMeeting')"
            >
              <template #text>
                <span class="text-18 font-bold">
                  {{ $t('end_meeting') }}
                </span>
              </template>
            </base-button>
            <base-button
              v-else
              radius="default"
              buttonType="danger-opacity"
              width="full"
              height="48"
              @click.native="$emit('deleteMeeting')"
            >
              <template #text>
                <span class="text-18 font-bold">
                  {{ $t('delete_meeting') }}
                </span>
              </template>
            </base-button>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>
<script>
import { mapGetters } from 'vuex';
import BaseModal from '@/components/modals/BaseModal.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import ReceiveSquare from '@/assets/icons/vue/receive-square.vue';
import Trash from '@/assets/icons/vue/trash.vue';

export default {
  name: 'EndMeetingModal',
  components: {
    BaseButton,
    BaseModal,
    ReceiveSquare,
    Trash,
  },
  props: {
    activeDetail: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme',
    }),
  },
  methods: {
    closeModals(...modals) {
      modals.map((modalName) => this.$store.dispatch('modal/close', modalName));
    },
  },
};
</script>
<style lang="css" scoped>
 .modal-title {
  @apply flex flex-col items-center justify-between relative;
}
.modal-footer {
  @apply py-34;
}
.modal-ring-danger {
  @apply rounded-full w-84 h-84 flex;
}
 .modal-ring-danger {
  @apply bg-dangerOpacity;
}
.title-description {
  @apply mt-20 text-18 text-title font-bold;
}
.title-interference {
  @apply mt-20 text-24 text-danger font-bold text-center;
}
.footer-button-section {
  @apply grid grid-cols-2 sm:grid-cols-1;
}
</style>
